import { useMemo } from "react";

/**
 * Returns the name of the view with the lowest position,
 * so clicking the parent nav item navigates to whichever view is first.
 */
export function useDefaultViewName(
  views: readonly { name: string; position: number }[] | undefined,
  fallback: string,
): string {
  return useMemo(() => {
    if (!views?.length) return fallback;
    const sorted = [...views].sort((a, b) => a.position - b.position);
    return sorted[0]?.name ?? fallback;
  }, [views, fallback]);
}
